import React, { useEffect, useState } from 'react'
import { Box, CardMedia, IconButton } from '@mui/material'
import DialogComponent from 'components/DialogComponent'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

const ImageSlider = ({ open, handleClose, files, title }) => {
    const [imgIdx, setImgIdx] = useState(0);

    const handleNext = () => {
        setImgIdx((prev) => prev + 1);
    };

    const handlePrev = () => {
        setImgIdx((prev) => prev - 1);
    };

    useEffect(() => {
        setImgIdx(0)
    }, [files])

    return (
        <DialogComponent
            title={title}
            open={open}
            handleClose={handleClose}
            maxWidth='md'
        >
            <Box key={imgIdx} sx={{ position: "relative" }}>
                <CardMedia
                    component="img"
                    sx={{ height: "500px", width: "100%", objectFit: "cover" }}
                    image={files?.[imgIdx]?.filePath || ""}
                    alt={"image"}
                />
                {
                    imgIdx > 0 && <IconButton
                        onClick={handlePrev}
                        sx={{
                            position: "absolute",
                            left: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.8)",
                            },
                            zIndex: 2,
                        }}>
                        <ArrowCircleLeftIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                }
                {
                    imgIdx < files?.length - 1 && <IconButton
                        onClick={handleNext}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.8)",
                            },
                            zIndex: 2,
                        }}>
                        <ArrowCircleRightIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                }
            </Box>
        </DialogComponent>
    )
}

export default ImageSlider
